import moment from "moment";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";
import { queryClient } from "../../router";
import { classNames } from "../../utils/classNames";
import Card from "../Reusable/Card";
import DataTable from "../Reusable/DataTable";
import Modal from "../Reusable/Modal";
import ConsignmentFilter from "./ConsignmentFilter";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
//@ts-ignore
import { OrderDetailPage, Remark } from "@careinfo/layout";
import { toast } from "react-toastify";
import OrderMenu from "./OrderMenu";
//@ts-ignore
import { ClientAccessControl } from "@careinfo/permission-required";
import Suborders from "./Suborders";
import TabPanel from "../Reusable/Tab";
import DraftOrderList from "../../pages/Consignment/DraftOrderList";
import Button from "../Reusable/Button";
const ConsignmentList = ({
  userPermissions,
  setDeletePopup,
  openDeletePopup,
  isRemoving,
  handleRemove,
}) => {
  const [searchParams, setSearchParms] = useSearchParams();

  const {
    register,
    setValue,
    getValues,
    watch,
    reset,
    clearErrors,
    formState: { errors },
  } = useForm({});
  const [isFilterVisible, setFilterVisiable] = useState(false);
  const [openReviewModal, setOpenReviewModal] = useState(false);
  const [selectedConsignment, setSelectedConsignment] = useState("");
  const [openSuborderpopup, setOpensuborderPopup] = useState(false);
  const [defaultValue, setDefaultValue] = useState(null);
  const [removeId, setRemoveId] = useState<null | string>(null);
  const [orderActionMenu, setOrderActionMenu] = useState(false);
  const [actionType, setActionType] = useState("");
  const [rowid, setRowid] = useState();
  const [receiver, setReceiver] = useState("");
  const selectedOrderDetails = searchParams.get("selectedItem");
  const handleFilterReset = () => {
    reset();
    setValue("is_rtv", null);
    setValue("Consignment_remarks__isnull", null);
    setValue("is_walking_customer", null);
    setValue("delivery_status__in", null);
    setDefaultValue(null);
  };

  const checkedAllItems = searchParams.get("selectAllItems") === "1";

  const handleIndividualSelect = (value: string) => {
    let selectedItems = searchParams.get("selectedItems")?.split(",");
    if (!selectedItems || !selectedItems === undefined) {
      searchParams.set("selectedItems", value);
      setSearchParms(searchParams);
      return;
    }
    let itemIndex = selectedItems?.findIndex((item) => item === value);
    if (itemIndex > -1) {
      selectedItems.splice(itemIndex, 1);
      const newSelectedItems = selectedItems
        ?.map((item) => item)
        .join(",")
        .toString();
      if (newSelectedItems.length) {
        searchParams.set("selectedItems", newSelectedItems);
      } else {
        searchParams.delete("selectedItems");
      }
      searchParams.set("selectAllItems", "0");
      setSearchParms(searchParams);
    } else {
      selectedItems?.push(value);
      const newSelectedItems = selectedItems
        ?.map((item) => item)
        .join(",")
        .toString();
      searchParams.set("selectedItems", newSelectedItems);
      setSearchParms(searchParams);
    }
  };

  const isSelected = (value: string) => {
    const selectedItems = searchParams.get("selectedItems")?.split(",");
    if (!selectedItems) {
      return false;
    }
    return selectedItems.includes(value);
  };

  const location = useLocation();
  const navigate = useNavigate();
  const appendSelectedItem = (selectedItem: any) => {
    const params = new URLSearchParams(location.search); // Get current search params
    params.set("selectedItem", selectedItem); // Add or update the "selectedItems" parameter

    // Construct the new full path
    const newFullPath = `${location.pathname}?${params.toString()}`;

    // Navigate to the new URL without reloading the page
    navigate(newFullPath, { replace: true });
  };
  const handleRecevierName = (row: any) => {
    setReceiver(row);
  };
  const handleSelectAll = (table: any) => {
    const {
      options: { data: tableData },
    } = table;
    const isSelected = searchParams.get("selectAllItems");
    if (isSelected === "1") {
      searchParams.set("selectAllItems", "0");
      searchParams.delete("selectedItems");
      setSearchParms(searchParams);
    } else {
      const selectedItems = tableData
        ?.map((item: any) => item.id)
        .join(",")
        .toString();
      searchParams.set("selectAllItems", "1");
      searchParams.set("selectedItems", selectedItems);
      setSearchParms(searchParams);
    }
  };
  let defaultColumns: any = [
    {
      id: "select",
      header: ({ table }: any) => {
        return (
          <input
            type="checkbox"
            checked={checkedAllItems}
            onChange={() => handleSelectAll(table)}
            className={tw`cursor-pointer`}
          />
        );
      },
      cell: ({ row }: any) => (
        <input
          type="checkbox"
          checked={isSelected(row?.original?.id)}
          onChange={() => handleIndividualSelect(row?.original?.id)}
          className={tw`cursor-pointer`}
        />
      ),
    },
    {
      header: "WayBill",
      accessorKey: "tracking_number",
      cell: ({ row, getValue }: any) => {
        return (
          <div
            onClick={() => {
              appendSelectedItem(row?.original?.id);
            }}
            className={tw`cursor-pointer`}
          >
            <ClientAccessControl
              allowedPermissions={["can_view_merchant_tracking"]}
            >
              <p
                className={classNames(
                  row?.original?.is_duplicate ? tw`text-red-600` : tw``,
                  tw`whitespace-nowrap`
                )}
              >
                {getValue() ?? "N/A"}
              </p>
            </ClientAccessControl>
            <p className={tw`text-xs text-gray-500`}>
              {moment(row?.original?.created).format("YY-MM-DD HH:mm:ss")}
            </p>
          </div>
        );
      },
    },
    {
      header: "Ref No.",
      accessorKey: "reference_number",
      cell: ({ getValue }: any) => {
        return (
          <ClientAccessControl
            children={<p> {getValue() || "N/A"} </p>}
            allowedPermissions={["can_view_merchant_reference"]}
          />
        );
      },
    },
    {
      header: "Origin",
      accessorKey: "pickup_branch.name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className={tw`uppercase`}>{getValue()}</p>
            <p className={tw`text-xs text-primary`}>
              {row?.original?.destination_branch?.warehouse?.name}
            </p>
          </>
        );
      },
    },
    {
      header: "Destination",
      accessorKey: "destination.name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className={tw`uppercase`}>{getValue()}</p>
            <p className={tw`text-xs text-primary`}>
              {row?.original?.destination_branch?.warehouse?.name}
            </p>
          </>
        );
      },
    },
    {
      header: "Receiver",
      accessorKey: "receiver.full_name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <ClientAccessControl
              allowedPermissions={["can_view_merchant_receiver_name"]}
            >
              <p className={tw`whitespace-nowrap`}>
                {row?.original?.receiver.full_name ?? "N/A"}{" "}
              </p>
            </ClientAccessControl>
            <ClientAccessControl
              allowedPermissions={["can_view_merchant_receiver_number"]}
            >
              <p className={tw`whitespace-nowrap text-sm`}>
                {row?.original?.receiver.primary_contact ?? "N/A"}{" "}
              </p>
            </ClientAccessControl>
            <ClientAccessControl
              allowedPermissions={["can_view_merchant_receiver_location"]}
            >
              <p className={tw`text-warp w-56 text-sm`}>
                {row?.original?.receiver.address ?? "N/A"}{" "}
              </p>
            </ClientAccessControl>
          </>
        );
      },
    },
    {
      header: "Piece",
      accessorKey: "piece",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <button
              className={tw`cursor-pointerb focus:outline-none`}
              onClick={() => {
                setOpensuborderPopup(!openSuborderpopup);
                setRowid(row?.original?.id);
              }}
            >
              {getValue() ?? 0.0}
            </button>
          </>
        );
      },
    },
    // {
    //   header: "Weight",
    //   accessorKey: "weight",
    //   cell: ({ row, getValue }: any) => {
    //     return (
    //       <>
    //         <p>
    //           {getValue()}
    //           <span className="text-gray-500 text-xs">Kgs</span>{" "}
    //         </p>
    //       </>
    //     );
    //   },
    // },
    {
      header: "Remarks",
      accessorKey: "remark",
      cell: ({ row, getValue }: any) => (
        <ClientAccessControl allowedPermissions={["can_view_merchant_remarks"]}>
          <div
            className={tw`cursor-pointer`}
            onClick={(e) => {
              setSelectedConsignment(row?.original?.id);
              e.stopPropagation();
              setOpenReviewModal(true);
              handleRecevierName(row?.original?.receiver.full_name);
            }}
          >
            <p>{getValue()} Remarks</p>
          </div>
        </ClientAccessControl>
      ),
    },
    {
      header: "Status",
      accessorKey: "delivery_status.name",
      cell: ({ row, getValue }: any) => {
        return (
          <ClientAccessControl
            allowedPermissions={["can_view_merchant_status"]}
          >
            <>
              {row?.original?.is_draft ? (
                <p
                  className={tw`uppercase px-1 text-center rounded-md`}
                  style={{ background: "#1C90E9" }}
                >
                  Draft
                </p>
              ) : (
                <p
                  className={tw`uppercase px-1 text-center rounded-md`}
                  style={{ background: row?.original?.delivery_status?.color }}
                >
                  {getValue()}
                </p>
              )}
              <p className={tw`text-xs text-primary `}>
                {row?.original?.rider?.name}
              </p>
            </>
          </ClientAccessControl>
        );
      },
    },
  ];
  const handleTabChange = (index: number) => {
    const cloned = new URLSearchParams(searchParams);
    cloned.set("tab", index === 0 ? "drafts" : "orders");
    setSearchParms(cloned);
  };
  const tab = searchParams.get("tab") || "drafts";
  const selectedTab = tab === "orders" ? 1 : 0;

  const filterParams = watch();

  return (
    <>
      <ClientAccessControl
        children={
          <Card
            title="Filters"
            onClick={() => setFilterVisiable(!isFilterVisible)}
          >
            <ConsignmentFilter
              isFilterVisible={isFilterVisible}
              register={register}
              errors={errors}
              setValue={setValue}
              getValues={getValues}
              reset={handleFilterReset}
              watch={watch}
              clearErrors={clearErrors}
              defaultValue={defaultValue}
              setDefaultValue={setDefaultValue}
            />
          </Card>
        }
        allowedPermissions={["can_edit_merchant_filter"]}
      />
      <TabPanel
        value={selectedTab}
        onChange={handleTabChange}
        tabTitle={["Draft Orders", "Orders"]}
        tabPanels={[
          <>
            <DraftOrderList />
            <Modal
              isOpen={openDeletePopup}
              title="Delete"
              setIsOpen={() => {
                setDeletePopup(false);
                setRemoveId(null);
              }}
            >
              <div
                className={tw`flex flex-col justify-center items-center h-fit`}
              >
                <p className={tw`text-lg font-semibold mb-4`}>
                  Are you sure you want to delete ?
                </p>
                <div
                  className={tw`grid grid-cols-2 place-items-center gap-x-4`}
                >
                  <div className={tw`w-24`}>
                    <Button
                      label={"Yes, Remove"}
                      isLoading={isRemoving}
                      disabled={isRemoving}
                      onClick={() => handleRemove(removeId)}
                    />
                  </div>
                  <button
                    type="button"
                    className={tw`w-full px-[24px] py-2 rounded focus:outline-none bg-[#EEF5F4]`}
                    onClick={() => {
                      setDeletePopup(!openDeletePopup);
                      setRemoveId(null);
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </Modal>
          </>,
          <DataTable
            url={APIS.ORDER}
            queryKey={"Consignments"}
            columns={defaultColumns}
            addNewPagePath={"/create"}
            tableName={"consignments-list"}
            params={{
              ...filterParams,
              is_rtv: filterParams?.is_rtv ? true : null,
              Consignment_remarks__isnull:
                filterParams?.Consignment_remarks__isnull ? false : null,
              is_walking_customer: filterParams?.is_walking_customer
                ? true
                : null,
              is_draft: false,
              delivery_status__in: filterParams?.delivery_status__in
                ?.map((item: any) => item.id)
                .join(","),
            }}
            actionMenu={
              <div className={tw`flex  w-full`}>
                <ClientAccessControl
                  children={
                    <OrderMenu
                      orderActionMenu={orderActionMenu}
                      setOrderActionMenu={setOrderActionMenu}
                      setActionType={setActionType}
                    />
                  }
                  allowedPermissions={["can_perform_merchant_action"]}
                />
              </div>
            }
          />,
        ]}
      />

      <Modal
        isOpen={openReviewModal}
        setIsOpen={setOpenReviewModal}
        title={"Remark"}
        children={
          <>
            <Remark selectedOrder={selectedConsignment} receiver={receiver} />
          </>
        }
      />

      <Modal
        isOpen={selectedOrderDetails ? true : false}
        setIsOpen={() => console.log("Popclose")}
        title={"Order Detail"}
        children={
          <>
            <OrderDetailPage selectedOrder={searchParams.get("selectedItem")} />
          </>
        }
      />
      <Modal
        isOpen={openSuborderpopup}
        setIsOpen={setOpensuborderPopup}
        title={"Sub Orders"}
      >
        <Suborders id={rowid} />
      </Modal>
    </>
  );
};

export default ConsignmentList;
